import axios from 'axios';

const FALLBACK_PAGE_SIZE = 10000;

// Follows the backend's lastEvaluatedKey to fetch every page, then resolves to a
// single axios-shaped response so the existing search reducer (and everything
// downstream) handles the full dataset unchanged.
//
// Backend contract (search-service must honor):
//   request:  { search: { tableName, rowCount, lastEvaluatedKey } }
//   response: { tableName, items, totalRows, lastEvaluatedKey }
//   - rowCount caps the page size
//   - lastEvaluatedKey echoes the start key (null/absent for the first page)
//   - response.lastEvaluatedKey is returned only while more rows remain, and
//     is null/absent on the final page
export default function searchAllPages(tableName, config, locationsList = false, pageSizeOverride) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.postSearchService;
  const actionType = locationsList ? 'SEARCH_LIST_FETCH' : 'SEARCH_FETCH';
  const pageSize = pageSizeOverride || FALLBACK_PAGE_SIZE;

  const fetchAllPages = async () => {
    let items = [];
    let totalRows = 0;
    let lastEvaluatedKey = null;

    do {
      // eslint-disable-next-line no-await-in-loop
      const response = await axios({
        method: 'post',
        url,
        headers,
        data: { search: { tableName, rowCount: pageSize, lastEvaluatedKey } }
      });
      const { items: pageItems = [], totalRows: pageTotal = 0, lastEvaluatedKey: nextKey = null } = response.data;
      items = items.concat(pageItems);
      totalRows = pageTotal;
      lastEvaluatedKey = nextKey;
    } while (lastEvaluatedKey);

    // Mimic the axios response shape the search reducer expects.
    return { data: { tableName, items, totalRows, lastEvaluatedKey: null } };
  };

  return dispatch => dispatch({ type: actionType, payload: fetchAllPages() });
}



// WEBPACK FOOTER //
// ./src/actions/searchAllPages.js